import {AuthenticationService} from "../../Services/AuthenticationService";
import {StateService} from "angular-ui-router";
import {EExternalProjectType, EKind, EStampType, IEmployeeVm, ITimeEntryTypeVm} from '../../Data/Data';
import {NotificationService} from '../../Services/NotificationService';
import {EntryQueueService} from '../../Services/EntryQueueService';
import {TimeQueueItem} from '../../Services/TimeQueueItem';
import {TimeEntryDataService} from '../../Services/TimeEntryDataService';
import {ConfirmDialog} from "../../Models/confirm-dialog";
import {SettingsDialog} from '../../Models/settings-dialog';
import {NavigationService} from '../../Services/NavigationService';

export class PersonHomeController {
  static controllerId = 'PersonHomeController';
  static $inject = [
    "$state",
    AuthenticationService.serviceId,
    NotificationService.serviceId,
    EntryQueueService.serviceId,
    TimeEntryDataService.serviceId,
    NavigationService.serviceId
  ];

  person: IEmployeeVm;
  confirmDialog = new ConfirmDialog();

  type: ITimeEntryTypeVm;
  settingsDialog = new SettingsDialog();

  constructor(private $state: StateService,
              private authentication: AuthenticationService,
              private notification: NotificationService,
              private queue: EntryQueueService,
              private timeEntryData: TimeEntryDataService,
              private navigation: NavigationService) {

    if (this.authentication.appUser.person) {
      this.person = this.authentication.appUser.person;
      this.loadType();
    }
    else {
      this.$state.go('login');
    }
  }

  get isOnline() {
    return this.authentication.serverAvailable;
  }

  private async loadType() {
    this.type = await this.timeEntryData.getDefault(EKind.Work);
  }

  canEnter() {
    return !!this.person.defaultProject
  }

  enter() {
    this.$state.go('enter', {person: this.person});
  }

  start() {
    this.$state.go('start', {person: this.person});
  }

  async leave() {
    this.queue.enqueue(new TimeQueueItem(this.type.id,0, EExternalProjectType.Proj,
      this.authentication.appUser.person.id, new Date(), EStampType.Stop));

    this.confirmDialog.open('Buchung gesendet', false, 2000);
  }

  openLastBookings() {
    this.$state.go('booking-list', {
      userId: this.authentication.appUser.person.id
    });
  }

  openAbsences() {
    this.$state.go('absence-list', {
      userId: this.authentication.appUser.person.id
    });
  }

  openExpenses() {
    this.$state.go('expense-list', {
      userId: this.authentication.appUser.person.id
    });
  }

  openSettings() {
    this.settingsDialog.open(async entry => {
        switch (entry.id) {
          case 'password':
            this.$state.go("settings");
            break;
          case 'logout':
            await
              this.logout();
            break;
        }
      }
    )
    ;
  }

  async logout() {
    await this.authentication.logout();
    this.navigation.goToState('login');
  }
}
